import { useCallback, useMemo, useState } from "react";
import Modal from "../../../../components/generic/Modal";
import { useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../../store/user/selectors";
import { Button, Tag } from "antd";
import dayjs from "../../../../utils/dayjs";
import DraggableTable from "../../../../components/shared/DraggableTable";
import httpClient from "../../../../api/httpClient";

const ManageColumnsModal = ({ columns, setColumns }) => {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const tenant_id = useSelector(selectSelectedTenantId);

  const onIndexChange = useCallback(
    async (updatedData, { toIndex, id }) => {
      try {
        setIsSubmitting(true);

        await httpClient.post("column", {
          id,
          new_index: toIndex,
          tenant_id,
          type: "updateIndex",
        });

        setColumns(
          updatedData.reduce((acc, item) => {
            acc[item.id] = item;
            return acc;
          }, {}),
        );

        setShowModal(false);
      } catch (error) {
        console.log("Error:", error);
      } finally {
        setIsSubmitting(false);
      }
    },
    [tenant_id, setColumns],
  );

  const tableColumns = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Count",
        dataIndex: "count",
        key: "count",
        render: (_, r) => (
          <Tag color="blue-inverse">{r?.tasks?.length || 0}</Tag>
        ),
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        render: (date) => dayjs(date).format("DD MMM YYYY"),
      },
    ],
    [],
  );

  const data = useMemo(
    () => Object.keys(columns).map((k) => columns[k]),
    [columns],
  );

  return (
    <>
      <Button onClick={() => setShowModal(true)}>Manage Column</Button>
      {showModal && (
        <Modal
          title="Manage Columns"
          open
          onCancel={() => setShowModal(false)}
          width={600}
          isProcessing={isSubmitting}
          footer={null}
        >
          <DraggableTable
            rowKey="id"
            columns={tableColumns}
            data={data}
            pagination={false}
            onIndexChange={onIndexChange}
            loading={isSubmitting}
          />
        </Modal>
      )}
    </>
  );
};

export default ManageColumnsModal;
